<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Select an interview for {{ practice.attributes.name }}
        </p>
        <button class="delete" @click="$emit('hide')"></button>
      </header>
      <section class="modal-card-body">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Keyword</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control has-icons-right mt-2">
                <input
                  type="text"
                  :class="['input', { 'is-danger': keywordError || error }]"
                  v-model="keyword"
                  name="keyword"
                  maxlength="20"
                  autofocus
                />
                <span
                  class="icon is-small is-right"
                  v-if="keywordError || error"
                  ><i class="fa fa-warning"></i
                ></span>
                <p v-if="keywordError || error" class="help is-danger">
                  {{ keywordError || error }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="is-scrolling">
          <table class="table is-striped mv1 is-fullwidth is-sticky">
            <thead>
              <th>Interview</th>
              <th>Kind</th>
              <th>Tags</th>
              <th>
                <div class="select">
                  <select v-model="tag" class="is-small">
                    <option value="">Filter By Tag</option>
                    <option v-for="tag in tags" :value="tag.name"
                      >{{ tag.name }} [{{ tag.taggingsCount }}]</option
                    >
                  </select>
                </div>
              </th>
            </thead>
            <tbody>
              <tr v-if="!loading" v-for="interview in interviews">
                <td>{{ interview.attributes.name }}</td>
                <td>{{ interview.attributes.kind }}</td>
                <td>
                  <span
                    class="multiselect__tag"
                    v-for="tag in interview.attributes.tagList"
                    >{{ tag }}</span
                  >
                </td>
                <td>
                  <button
                    type="button"
                    :class="[
                      'button',
                      'is-small',
                      { 'is-loading': showLoading(interview.id) }
                    ]"
                    @click="preAssign(interview.id)"
                  >
                    Assign
                  </button>
                </td>
              </tr>
              <tr v-if="loading">
                <td colspan="4" class="has-text-centered mt1">
                  <i class="fa fa-refresh fa-spin"></i>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4">
                  <pager
                    :current="currentPage"
                    :total="pageCount"
                    :onClick="getInterviews"
                  />
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <vue-toastr ref="toastr"></vue-toastr>
      </section>
      <footer class="modal-card-foot">
        <a class="button" @click="$emit('hide')">Cancel</a>
      </footer>
    </div>
  </div>
</template>

<script>
import InterviewsService from "@/services/InterviewsService";
import pager from "./Pager";

export default {
  name: "interview-selector",

  components: {
    pager
  },

  props: ["practice", "onAssign", "loadingId", "keywordError"],

  data() {
    return {
      tag: "",
      keyword: "",
      error: "",
      loading: false
    };
  },

  computed: {
    interviews() {
      let tags = null;
      if (this.tag.length) {
        tags = this.$store.getters["interview/poolByTag"](this.tag);
      } else {
        tags = this.$store.getters["interview/pool"];
      }
      return tags;
    },
    tags() {
      return this.$store.getters["interview/tags"];
    },
    currentPage() {
      return this.$store.getters["interview/currentPage"];
    },
    pageCount() {
      return this.$store.getters["interview/pageCount"];
    }
  },

  methods: {
    preAssign(id) {
      this.error = "";
      if (!this.keyword) {
        this.error = "A keyword is required.";
        this.$refs.toastr.e("Please enter a keyword for this interview.");
      } else {
        this.onAssign(id, this.keyword);
      }
    },
    showLoading(id) {
      return this.loadingId === id;
    },
    getInterviews(page = 1) {
      this.loading = true;
      InterviewsService.getPool(page).then(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-card-body {
  max-height: 400px;
}
.is-scrolling {
  overflow: auto;
  height: 16rem;
}
.is-sticky {
  thead {
    th {
      background: #f9f9f9;
      z-index: 10;
      position: sticky;
      top: 0;
    }
  }
}
select {
  &.is-small {
    font-size: 0.84rem;
    padding: 0.41rem;
  }
}
</style>
